// extracted by mini-css-extract-plugin
module.exports = {"root":"BackButton_root__360Q5"};